import axios from "axios";
import { baseUrl } from "../Constant";

// const getCommonHeaders = async (headers) => {
//   if (headers) {
//     if (headers["Content-Type"] === undefined) {
//       headers["Content-Type"] = "application/json";
//     }
//     headers["Access-Control-Allow-Origin"] = "*";
//   }

//   let token = await jwt();

//   if (token) {
//     headers.Authorization = `Bearer ${token}`;
//   }
//   return headers;
// };

const jwt = async () => {
  try {
    const data = await localStorage.getItem("token");
    if (data !== null) {
      return data;
    }
  } catch (error) {}
};

export async function apiGet(endPoint, onSuccess, onFailure) {
  let token = await jwt();
  axios
    .get(baseUrl + endPoint, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      if (onSuccess) onSuccess(response.data);
    })
    .catch((error) => {
      if (onFailure) onFailure(error);
    });
}

export async function apiPost(endPoint, onSuccess, onFailure, body, headers) {
  let token = await jwt();
  axios
    .post(baseUrl + endPoint, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if (onSuccess) onSuccess(response.data);
    })
    .catch((error) => {
      if (onFailure) onFailure(error);
    });
}

export async function apiPut(endPoint, onSuccess, onFailure, body, headers) {
  let token = await jwt();

  axios
    .put(baseUrl + endPoint, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if (onSuccess) onSuccess(response.data);
    })
    .catch((error) => {
      if (onFailure) onFailure(error);
    });
}

export async function apiDelete(endPoint, onSuccess, onFailure, headers) {
  let token = await jwt();

  axios
    .delete(baseUrl + endPoint, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if (onSuccess) onSuccess(response.data);
    })
    .catch((error) => {
      if (onFailure) onFailure(error);
    });
}

export async function apiPatch(endPoint, onSuccess, onFailure, body, headers) {
  let token = await jwt();
  axios
    .patch(baseUrl + endPoint, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if (onSuccess) onSuccess(response.data);
    })
    .catch((error) => {
      if (onFailure) onFailure(error);
    });
}
